<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-group">
            <label>Version: *</label><br />
            <input type="text" name="version" v-model="finalData.version" required />
        </div>
        <div class="form-group">
            <label>Description: *</label><br />
            <textarea v-model="finalData.description" required></textarea>
        </div>
        <div class="form-group">
            <label>Installer File (.exe): *</label><br>
            <input type="file" v-on:change="exeFileSelected" name="version_file" required />
        </div>
        <div class="form-group">
            <label>Appcast File (.xml): *</label><br>
            <input type="file" v-on:change="appcastFileSelected" name="appcast_file" required />
        </div>
        <div class="form-group">
            <label>Appcast Signature (.signature): *</label><br>
            <input type="file" v-on:change="signatureFileSelected" name="signature_file" required />
        </div>
        <div class="form-group">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'VersionForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : {},
            exeFile: null,
            appcastFile: null,
            signatureFile: null
        }
    },
    methods: {
        exeFileSelected(e) {
            this.exeFile = e.target.files[0]
        },
        appcastFileSelected(e) {
            this.appcastFile = e.target.files[0]
        },
        signatureFileSelected(e) {
            this.signatureFile = e.target.files[0]
        },
        submitForm(e) {
            e.preventDefault()
            if (this.exeFile === null || this.appcastFile === null || this.signatureFile === null) {
                alert('Files missing')
                return false
            }
            const fd = new FormData()
            for (let k in this.finalData) {
                fd.append(k, this.finalData[k])
            }
            fd.append('version_file', this.exeFile)
            fd.append('appcast_file', this.appcastFile)
            fd.append('signature_file', this.signatureFile)
            this.$emit('formSubmitted', fd)
        }
    }
}
</script>

<style lang="scss" scoped>
.existing-file {
    display: block;
    width: fit-content;
    padding: 2px;
    margin-bottom: 2px;
    border: 1px solid #aaa;
}
</style>
